import { useQuery } from "@tanstack/react-query";
import { guestBookingApi } from "../api";

/** Public settings: guest booking (GUEST_BOOKING_ENABLED) and SMS availability (SMS_PROVIDER). */
function usePublicSettings() {
  return useQuery({
    queryKey: ["public", "booking-settings"],
    queryFn: async () => (await guestBookingApi.settings()).data,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}

/** Whether patients may book without signing in (API flag GUEST_BOOKING_ENABLED). */
export function useGuestBookingEnabled() {
  const query = usePublicSettings();
  return { enabled: query.data?.guestBookingEnabled === true, isPending: query.isPending };
}

/**
 * Whether codes can be sent by SMS. False with SMS_PROVIDER=none (email-only):
 * registration and guest booking then require an email address.
 * Assumes SMS until the settings load, so nothing flickers on SMS deployments.
 */
export function useSmsEnabled() {
  const query = usePublicSettings();
  return query.data?.smsEnabled !== false;
}
